import {BaseModel} from '../../_base/crud';

export class TrainingDocument extends BaseModel {
    id: number;
    name: string;

    file: string;
    training_document_file: any[];

    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    user_deleted: Date;

    deletedBy: string;
    userDeletedBy: string;

    createdBy: string;
    lastUpdatedBy: string;

    clear(): void {
        this.id = undefined;
        this.name = '';

        this.file = '';
        this.training_document_file = [];

        this.created_at = new Date();
        this.updated_at = new Date();
        this.deleted_at = null;
        this.user_deleted = null;

        this.deletedBy = '';
        this.userDeletedBy = '';
    }
}
